module.exports = __webpack_public_path__ + "img/position.43832f0b.png";